import React from "react";

import Main from "../layout/Main";

const Landing = ({ children }) => <Main>{children}</Main>;

export default Landing;
